<template>
  <div class="w-collect" :style="{top:color?'0':'10px',right:color?'0':'10px',position:color?'relative':'absolute'}">
    <template v-if="!isCollect">
      <img v-if="color" :style="likeStyle" src="@/assets/img/icon-like-grey.svg" />
      <img v-else :style="likeStyle" src="@/assets/img/icon-like.png" />
    </template>
    <img v-if="isCollect" :style="likeStyle"  src="@/assets/img/icon-liked.png" />
    <span :style="{color:color||'#ffffff',fontSize: fontSize+'px'}">{{number > 0 ? number : 0}}</span>
  </div>
</template>

<script>

export default {
  props: {
    objId: {
      type: String
    },
    type: {
      type: Number
    },
    number: {
      type: Number
    },
    isCollect: {
      type: Boolean
    },
    color:{
      type: String,
      default: ''
    },
    width:{
      type: Number,
      default:24
    },
    height:{
      type: Number,
      default:24
    },
    fontSize: {
      type: Number,
      default: 12
    }
  },
  computed: {
    likeStyle(){
      return {
        width: this.width + 'px',
        height: this.height + 'px',
      }
    }
  },
};
</script>

<style scoped>
.w-collect {
  position: absolute;
}

.w-collect {
  position: absolute;
  display: flex;
  align-items: center;
  top: 10px;
  right: 10px;
  z-index: 1;
}


.w-collect span {
  margin-left: 3px;
  font-weight: 500;
  font-size: 12px;
  text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.35);
}
</style>
